module.exports = __webpack_public_path__ + "static/media/walk.d47c038d.jpg";